const urlParams = new URLSearchParams(window.location.search);

// Extract the token from the query parameters
const token = urlParams.get("token");
// console.log(token); // Logs the token value correctly

// const token = "8407|mBUfrI2LRogOa9r8luCYCRsz06eMBUMEQm93jjhqeb2b8177";
export const CpTopRank = async () => {
  try {
    const response = await fetch("https://new.smolivechat.com/api/CpTopRank", {
      method: "get", // You can also specify POST if needed
      headers: {
        "Content-Type": "application/json", // Add any necessary content type headers
        Authorization: `Bearer ${token}`, // Use the token passed to the function
        "Custom-Header": "YourCustomHeaderValue", // Add any other custom headers if needed
      },
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data; // Return the parsed JSON data
  } catch (error) {
    throw new Error(error.message); // Handle errors if the request fails
  }
};
export const CpTopRankAllEvents = async () => {
  try {
    const response = await fetch(
      "https://new.smolivechat.com/api/cp-top-rans-all-events",
      {
        method: "get", // You can also specify POST if needed
        headers: {
          "Content-Type": "application/json", // Add any necessary content type headers
          Authorization: `Bearer ${token}`, // Use the token passed to the function
          "Custom-Header": "YourCustomHeaderValue", // Add any other custom headers if needed
        },
      },
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data; // Return the parsed JSON data
  } catch (error) {
    throw new Error(error.message); // Handle errors if the request fails
  }
};
